import type { ITraveler } from "@hopper-b2b/types";
import dayjs from "dayjs";

export const getTravelerAgeBand = (
  traveler: ITraveler,
  ageBands: Array<{ ageBand: string; lowerBound?: number; upperBound?: number }>
): string | undefined => {
  if (!traveler.dateOfBirth || !ageBands?.length) return undefined;

  const age = dayjs().diff(dayjs(traveler.dateOfBirth), "year");

  for (const band of ageBands) {
    const lower = band.lowerBound ?? 0;
    const upper = band.upperBound ?? 130;
    if (age >= lower && age <= upper) {
      return band.ageBand;
    }
  }

  return undefined;
};
